import { Component, OnInit ,HostListener } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
declare var $:any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {

  public loading:boolean = true;
  public detaildata:any=[];
  // public AlbumList:any =[];
  // public b_AlbumList:any=[];
  public loginDetail:any =[];

  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");  
    this.getData();
  }

  ngOnInit(): void {    
  }
 
  getData(){
  const url = "/dashboard-count"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {           
        this.detaildata=response.data; 
        this.loading=false;  
      } else {
        this.loading=false;  
      }
    }), (error) => { this.loading =false; });
  }

  redirectCheck(){
    if(this.loginDetail.profile_complete ==true){
      this.router.navigate(['/create-single-post']);
    } else {
      this.service.dangerAlert('Please complete your profile first');
    }
  }

}
